import { gql, useQuery } from '@apollo/client';

export enum FeatureFlag {
  BatchScheduling = 'scheduling_batch_scheduling',
  HiringMeetings = 'scheduling_redesign_hiring_meeting',
  PreferShorterBlockGap = 'scheduling_prefer_shorter_block_gap',
  SchedulingWithoutBlocks = 'scheduling_scheduling_without_blocks',
}

const FEATURE_FLAG_QUERY = gql`
  query FeatureFlag {
    user {
      id
      featureFlags
    }
  }
`;

interface FeatureFlagData {
  user: {
    id: string;
    featureFlags: string[];
  } | null;
}

export function useFeatureFlag (flag: FeatureFlag): boolean {
  const { data } = useQuery<FeatureFlagData>(FEATURE_FLAG_QUERY);
  return data?.user?.featureFlags?.includes(flag) ?? false;
}
